var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entity-analysis"},[_c('EntityAnalysis',{ref:"ea",attrs:{"showResults":false,"disableTextArea":true,"textAreaClass":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }